<template>
  <div id="app">
    <!-- 前台页面：显示导航栏和页脚 -->
    <template v-if="!isAdminRoute">
      <!-- 流星雨背景 -->
      <div class="stars-background">
        <div v-for="i in 50" :key="i" class="star" :style="getStarStyle(i)"></div>
      </div>
      <el-container>
        <el-header>
          <div class="header-content">
            <div class="header-logo" @click="goToHome">
              <span class="logo-text">MKCases</span>
            </div>
            <el-menu
              :default-active="activeMenu"
              mode="horizontal"
              router
              class="header-menu"
            >
              <el-menu-item index="/">首页</el-menu-item>
              <el-menu-item index="/market">第三方市场</el-menu-item>
              <el-menu-item index="/tools">AI工具雷达</el-menu-item>
              <el-menu-item index="/prompts">常用提示词</el-menu-item>
              <el-menu-item index="/agents">智能体示例</el-menu-item>
              <el-menu-item index="/about">关于</el-menu-item>
            </el-menu>
          </div>
        </el-header>
        <el-main>
          <router-view />
        </el-main>
        <el-footer>
          <FooterComponent />
        </el-footer>
      </el-container>
    </template>
    
    <!-- 后台页面：只显示内容，不显示导航栏和页脚 -->
    <template v-else>
      <router-view />
    </template>
  </div>
</template>

<script>
import FooterComponent from './components/Footer.vue'

export default {
  name: 'App',
  components: {
    FooterComponent
  },
  computed: {
    activeMenu() {
      return this.$route.path
    },
    isAdminRoute() {
      return this.$route.path.startsWith('/admin')
    }
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    getStarStyle(_index) {
      const size = Math.random() * 2 + 1
      const left = Math.random() * 100
      const top = Math.random() * 100
      const duration = Math.random() * 3 + 2
      const delay = Math.random() * 2
      return {
        width: `${size}px`,
        height: `${size}px`,
        left: `${left}%`,
        top: `${top}%`,
        animationDuration: `${duration}s`,
        animationDelay: `${delay}s`
      }
    },
    goToHome() {
      this.$router.push('/')
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
  background: #0a0a0a;
  background-image: 
    radial-gradient(circle at 20% 50%, rgba(0, 150, 255, 0.1) 0%, transparent 50%),
    radial-gradient(circle at 80% 80%, rgba(138, 43, 226, 0.1) 0%, transparent 50%),
    radial-gradient(circle at 40% 20%, rgba(0, 255, 255, 0.05) 0%, transparent 50%);
}

/* 流星雨背景 */
.stars-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
  overflow: hidden;
}

.star {
  position: absolute;
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 0 6px rgba(255, 255, 255, 0.8),
              0 0 12px rgba(0, 150, 255, 0.6),
              0 0 18px rgba(138, 43, 226, 0.4);
  animation: twinkle linear infinite;
}

@keyframes twinkle {
  0%, 100% {
    opacity: 0.3;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.2);
  }
}

.el-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 1;
}

.el-header {
  background: rgba(15, 15, 25, 0.95) !important;
  backdrop-filter: blur(15px);
  border-bottom: 1px solid rgba(0, 150, 255, 0.2);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
  color: #fff;
  padding: 0;
  height: 70px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 10;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 0 40px;
  max-width: 1400px;
  margin: 0 auto;
}

.header-logo {
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 8px 16px;
  border-radius: 6px;
  flex-shrink: 0;
}

.header-menu {
  flex: 1;
  display: flex;
  justify-content: center;
  margin: 0 auto;
}

.header-logo:hover {
  background-color: rgba(0, 212, 255, 0.1);
  transform: translateY(-50%) scale(1.05);
}

.logo-text {
  font-size: 24px;
  font-weight: bold;
  color: #00d4ff;
  text-shadow: 0 0 10px rgba(0, 212, 255, 0.6),
               0 0 20px rgba(0, 212, 255, 0.4),
               0 0 30px rgba(0, 150, 255, 0.2);
  letter-spacing: 2px;
  transition: all 0.3s ease;
  display: inline-block;
}

.header-logo:hover .logo-text {
  color: #00e4ff;
  text-shadow: 0 0 15px rgba(0, 212, 255, 0.8),
               0 0 25px rgba(0, 212, 255, 0.6),
               0 0 35px rgba(0, 150, 255, 0.4);
  transform: scale(1.05);
}

.header-menu {
  background-color: transparent !important;
  border: none !important;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.header-menu .el-menu--horizontal {
  background-color: transparent !important;
  border: none !important;
}

.header-menu .el-menu-item {
  color: rgba(255, 255, 255, 0.9) !important;
  border-bottom: 2px solid transparent;
  font-size: 16px;
  font-weight: 500;
  margin: 0 10px;
  padding: 0 20px;
  height: 100%;
  line-height: 70px;
  transition: all 0.3s ease;
  position: relative;
}

.header-menu .el-menu-item::before {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 2px;
  background: linear-gradient(90deg, #00d4ff, #0096ff);
  transition: width 0.3s ease;
  box-shadow: 0 0 6px rgba(0, 212, 255, 0.5);
}

.header-menu .el-menu-item:hover {
  color: #00d4ff !important;
  background-color: rgba(0, 150, 255, 0.15) !important;
}

.header-menu .el-menu-item:hover::before {
  width: 80%;
  box-shadow: 0 0 8px rgba(0, 212, 255, 0.7);
}

.header-menu .el-menu-item.is-active {
  color: #00d4ff !important;
  background-color: rgba(0, 150, 255, 0.2) !important;
}

.header-menu .el-menu-item.is-active::before {
  width: 100%;
  background: linear-gradient(90deg, #00d4ff, #0096ff);
  box-shadow: 0 0 10px rgba(0, 212, 255, 0.8);
}

/* 强制覆盖Element Plus默认的白色悬浮样式 */
.header-menu .el-menu-item:hover,
.header-menu .el-menu-item:focus {
  color: #00d4ff !important;
}

.header-menu .el-menu--horizontal .el-menu-item:hover,
.header-menu .el-menu--horizontal .el-menu-item:focus {
  color: #00d4ff !important;
  background-color: rgba(0, 150, 255, 0.15) !important;
}

.el-main {
  flex: 1;
  padding: 20px;
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  background: rgba(10, 10, 10, 0.6);
  backdrop-filter: blur(5px);
  color: #e0e0e0;
  position: relative;
  z-index: 1;
}

.el-footer {
  background: rgba(10, 10, 10, 0.98) !important;
  border-top: 1px solid rgba(0, 150, 255, 0.2);
  padding: 20px;
  text-align: center;
  margin-top: auto;
  color: rgba(255, 255, 255, 0.7);
  position: relative;
  z-index: 1;
}

/* 全局样式 - 确保内容在黑色背景下可见 */
.el-card {
  background: rgba(20, 20, 30, 0.8) !important;
  border: 1px solid rgba(0, 150, 255, 0.2) !important;
  color: #e0e0e0 !important;
  backdrop-filter: blur(5px);
}

.el-card:hover {
  border-color: rgba(0, 255, 255, 0.5) !important;
  box-shadow: 0 4px 20px rgba(0, 150, 255, 0.3) !important;
}

.el-tabs {
  color: #e0e0e0;
}

.el-tabs__item {
  color: rgba(255, 255, 255, 0.7) !important;
}

.el-tabs__item.is-active {
  color: #00ffff !important;
}

.el-tabs__active-bar {
  background-color: #00ffff !important;
  box-shadow: 0 0 10px rgba(0, 255, 255, 0.8);
}

.el-pagination {
  color: #e0e0e0 !important;
  background-color: transparent !important;
}

.el-pagination .el-pager {
  background-color: transparent !important;
}

.el-pagination .el-pager li {
  background-color: rgba(20, 20, 30, 0.9) !important;
  color: #e0e0e0 !important;
  border: 1px solid rgba(0, 150, 255, 0.3) !important;
}

.el-pagination .el-pager li:hover {
  background-color: rgba(0, 150, 255, 0.2) !important;
  color: #00d4ff !important;
}

.el-pagination .el-pager li.is-active {
  background-color: rgba(0, 150, 255, 0.4) !important;
  color: #00d4ff !important;
  border-color: #00d4ff !important;
}

.el-pagination button {
  background-color: rgba(20, 20, 30, 0.9) !important;
  color: #e0e0e0 !important;
  border: 1px solid rgba(0, 150, 255, 0.3) !important;
}

.el-pagination button:hover {
  background-color: rgba(0, 150, 255, 0.2) !important;
  color: #00d4ff !important;
}

.el-pagination .el-pagination__total,
.el-pagination .el-pagination__sizes,
.el-pagination .el-pagination__jump {
  color: #e0e0e0 !important;
}

.el-pagination .el-select .el-input__inner {
  background-color: rgba(20, 20, 30, 0.9) !important;
  border-color: rgba(0, 150, 255, 0.3) !important;
  color: #e0e0e0 !important;
}

.el-pagination .el-input__inner {
  background-color: rgba(20, 20, 30, 0.9) !important;
  border-color: rgba(0, 150, 255, 0.3) !important;
  color: #e0e0e0 !important;
}

h1, h2, h3, h4, h5, h6 {
  color: #e0e0e0;
}

p, span, div {
  color: #d0d0d0;
}

/* 确保所有文本在暗色背景下可见 */
.el-main * {
  color: inherit;
}

.el-main p, .el-main span, .el-main div {
  color: #d0d0d0;
}

.el-main h1, .el-main h2, .el-main h3, .el-main h4, .el-main h5, .el-main h6 {
  color: #e0e0e0;
}

/* Element Plus 组件在暗色主题下的调整 - 美化 */
.el-button {
  background: linear-gradient(135deg, rgba(0, 150, 255, 0.3), rgba(0, 212, 255, 0.2)) !important;
  border-color: rgba(0, 150, 255, 0.5) !important;
  color: #00d4ff !important;
  border-radius: 6px;
  transition: all 0.3s ease;
  font-weight: 500;
}

.el-button:hover {
  background: linear-gradient(135deg, rgba(0, 150, 255, 0.5), rgba(0, 212, 255, 0.4)) !important;
  border-color: #00d4ff !important;
  box-shadow: 0 4px 15px rgba(0, 212, 255, 0.4);
  transform: translateY(-2px);
}

.el-button--primary {
  background: linear-gradient(135deg, #0096ff, #00d4ff) !important;
  border-color: #00d4ff !important;
  color: #fff !important;
}

.el-button--primary:hover {
  background: linear-gradient(135deg, #00b4ff, #00e4ff) !important;
  box-shadow: 0 4px 20px rgba(0, 212, 255, 0.6);
}

.el-button--danger {
  background: linear-gradient(135deg, rgba(245, 108, 108, 0.3), rgba(255, 77, 77, 0.2)) !important;
  border-color: rgba(245, 108, 108, 0.5) !important;
  color: #f56c6c !important;
}

.el-button--danger:hover {
  background: linear-gradient(135deg, rgba(245, 108, 108, 0.5), rgba(255, 77, 77, 0.4)) !important;
  box-shadow: 0 4px 15px rgba(245, 108, 108, 0.4);
}

.el-input__inner {
  background-color: rgba(20, 20, 30, 0.8) !important;
  border-color: rgba(0, 150, 255, 0.3) !important;
  color: #e0e0e0 !important;
}

.el-input__inner:focus {
  border-color: #00d4ff !important;
  box-shadow: 0 0 10px rgba(0, 212, 255, 0.3);
}

.el-input__wrapper {
  background-color: rgba(20, 20, 30, 0.8) !important;
  box-shadow: 0 0 0 1px rgba(0, 150, 255, 0.3) inset !important;
}

.el-input__wrapper.is-focus {
  box-shadow: 0 0 0 1px #00d4ff inset !important;
}

.el-input__inner::placeholder {
  color: rgba(255, 255, 255, 0.5) !important;
}

/* Textarea 文本域样式 */
.el-textarea {
  background-color: transparent !important;
}

.el-textarea__inner {
  background-color: rgba(20, 20, 30, 0.9) !important;
  border: 1px solid rgba(0, 150, 255, 0.3) !important;
  color: #e0e0e0 !important;
  box-shadow: 0 0 0 1px rgba(0, 150, 255, 0.3) inset !important;
}

.el-textarea__inner:focus {
  border-color: #00d4ff !important;
  box-shadow: 0 0 0 1px #00d4ff inset, 0 0 10px rgba(0, 212, 255, 0.3) !important;
}

.el-textarea__inner::placeholder {
  color: rgba(255, 255, 255, 0.5) !important;
}

/* Select 下拉框样式 */
.el-select {
  width: 100%;
}

.el-select .el-input__wrapper {
  background-color: rgba(20, 20, 30, 0.9) !important;
  box-shadow: 0 0 0 1px rgba(0, 150, 255, 0.3) inset !important;
}

.el-select .el-input__wrapper.is-focus {
  box-shadow: 0 0 0 1px #00d4ff inset !important;
}

.el-select .el-input__inner {
  background-color: transparent !important;
  border: none !important;
  color: #e0e0e0 !important;
}

.el-select .el-input__suffix {
  color: #e0e0e0 !important;
}

.el-select-dropdown {
  background-color: rgba(20, 20, 30, 0.98) !important;
  border: 1px solid rgba(0, 150, 255, 0.3) !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.8) !important;
}

.el-select-dropdown__item {
  background-color: transparent !important;
  color: #e0e0e0 !important;
}

.el-select-dropdown__item:hover {
  background-color: rgba(0, 150, 255, 0.2) !important;
  color: #00d4ff !important;
}

.el-select-dropdown__item.selected {
  background-color: rgba(0, 150, 255, 0.3) !important;
  color: #00d4ff !important;
}

.el-select-dropdown__item.is-disabled {
  color: rgba(255, 255, 255, 0.3) !important;
}

/* Dropdown 下拉菜单样式 */
.el-dropdown {
  color: #e0e0e0 !important;
}

.el-dropdown-menu {
  background-color: rgba(20, 20, 30, 0.98) !important;
  border: 1px solid rgba(0, 150, 255, 0.3) !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.8) !important;
  padding: 4px 0 !important;
}

.el-dropdown-menu__item {
  background-color: transparent !important;
  color: #e0e0e0 !important;
  padding: 8px 20px !important;
}

.el-dropdown-menu__item:hover {
  background-color: rgba(0, 150, 255, 0.2) !important;
  color: #00d4ff !important;
}

.el-dropdown-menu__item:focus {
  background-color: rgba(0, 150, 255, 0.2) !important;
  color: #00d4ff !important;
}

.el-dropdown-menu__item.is-disabled {
  color: rgba(255, 255, 255, 0.3) !important;
  cursor: not-allowed !important;
}

.el-dropdown-menu__item.is-disabled:hover {
  background-color: transparent !important;
  color: rgba(255, 255, 255, 0.3) !important;
}

/* Tag 标签样式 */
.el-tag {
  background-color: rgba(0, 150, 255, 0.2) !important;
  border-color: rgba(0, 150, 255, 0.4) !important;
  color: #00d4ff !important;
}

.el-tag--success {
  background-color: rgba(103, 194, 58, 0.2) !important;
  border-color: rgba(103, 194, 58, 0.4) !important;
  color: #67c23a !important;
}

.el-tag--info {
  background-color: rgba(144, 147, 153, 0.2) !important;
  border-color: rgba(144, 147, 153, 0.4) !important;
  color: #909399 !important;
}

.el-tag--warning {
  background: linear-gradient(135deg, rgba(230, 162, 60, 0.3), rgba(255, 193, 7, 0.2)) !important;
  border-color: rgba(230, 162, 60, 0.5) !important;
  color: #ffc107 !important;
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(230, 162, 60, 0.3);
}

.el-tag--danger {
  background-color: rgba(245, 108, 108, 0.2) !important;
  border-color: rgba(245, 108, 108, 0.4) !important;
  color: #f56c6c !important;
}

/* Empty 空状态样式 */
.el-empty {
  color: rgba(255, 255, 255, 0.6) !important;
}

.el-empty__description {
  color: rgba(255, 255, 255, 0.6) !important;
}

/* Message 消息样式 */
.el-message {
  background-color: rgba(20, 20, 30, 0.95) !important;
  border-color: rgba(0, 150, 255, 0.3) !important;
  color: #e0e0e0 !important;
}

.el-message--success {
  border-color: rgba(103, 194, 58, 0.5) !important;
}

.el-message--error {
  border-color: rgba(245, 108, 108, 0.5) !important;
}

/* MessageBox 确认对话框样式 */
.el-message-box {
  background-color: rgba(20, 20, 30, 0.95) !important;
  border: 1px solid rgba(0, 150, 255, 0.3) !important;
  color: #e0e0e0 !important;
  backdrop-filter: blur(10px);
}

.el-message-box__title {
  color: #e0e0e0 !important;
}

.el-message-box__message {
  color: rgba(255, 255, 255, 0.8) !important;
}

.el-message-box__message p {
  color: rgba(255, 255, 255, 0.8) !important;
}

.el-message-box__btns {
  padding-top: 20px;
}

.el-message-box__btns .el-button {
  background-color: rgba(20, 20, 30, 0.9) !important;
  border-color: rgba(0, 150, 255, 0.3) !important;
  color: #e0e0e0 !important;
}

.el-message-box__btns .el-button:hover {
  background-color: rgba(0, 150, 255, 0.2) !important;
  border-color: rgba(0, 150, 255, 0.5) !important;
  color: #00ffff !important;
}

.el-message-box__btns .el-button--primary {
  background-color: rgba(0, 150, 255, 0.3) !important;
  border-color: rgba(0, 150, 255, 0.5) !important;
  color: #00ffff !important;
}

.el-message-box__btns .el-button--primary:hover {
  background-color: rgba(0, 150, 255, 0.5) !important;
  border-color: rgba(0, 150, 255, 0.7) !important;
}

.el-message-box__header {
  padding-bottom: 15px;
  border-bottom: 1px solid rgba(0, 150, 255, 0.2) !important;
}

.el-message-box__headerbtn {
  color: rgba(255, 255, 255, 0.6) !important;
}

.el-message-box__headerbtn:hover {
  color: #00ffff !important;
}

.el-message-box__status {
  color: rgba(255, 193, 7, 0.8) !important;
}

/* 确保所有Element Plus组件背景透明或暗色 */
.el-popper {
  background-color: rgba(20, 20, 30, 0.95) !important;
  border: 1px solid rgba(0, 150, 255, 0.3) !important;
}

.el-popper__arrow::before {
  background-color: rgba(20, 20, 30, 0.95) !important;
  border: 1px solid rgba(0, 150, 255, 0.3) !important;
}

/* 强制覆盖所有可能的白色背景 */
.el-select__wrapper,
.el-input__wrapper,
.el-pagination__sizes .el-select .el-input__wrapper,
.el-pagination__jump .el-input__wrapper {
  background-color: rgba(20, 20, 30, 0.9) !important;
  box-shadow: 0 0 0 1px rgba(0, 150, 255, 0.3) inset !important;
}

/* 确保所有输入框和选择框的文本颜色 */
.el-select__placeholder,
.el-input__placeholder {
  color: rgba(255, 255, 255, 0.5) !important;
}

/* 覆盖Element Plus的默认背景色 */
.el-select,
.el-input,
.el-pagination {
  --el-bg-color: rgba(20, 20, 30, 0.9) !important;
  --el-text-color-primary: #e0e0e0 !important;
  --el-text-color-regular: #d0d0d0 !important;
  --el-border-color: rgba(0, 150, 255, 0.3) !important;
}

/* 确保页脚容器也是暗色 */
.el-footer * {
  background-color: transparent !important;
}

/* Table 表格样式 - 美化 */
.el-table {
  background-color: rgba(20, 20, 30, 0.9) !important;
  color: #e0e0e0 !important;
  border-color: rgba(0, 150, 255, 0.3) !important;
  border-radius: 8px;
  overflow: hidden;
}

.el-table th.el-table__cell {
  background: linear-gradient(135deg, rgba(0, 150, 255, 0.2), rgba(0, 212, 255, 0.1)) !important;
  color: #e0e0e0 !important;
  border-color: rgba(0, 150, 255, 0.3) !important;
  font-weight: 600;
  font-size: 14px;
  padding: 15px 10px !important;
}

.el-table td.el-table__cell {
  background-color: rgba(20, 20, 30, 0.9) !important;
  color: #e0e0e0 !important;
  border-color: rgba(0, 150, 255, 0.2) !important;
  padding: 15px 10px !important;
  transition: all 0.3s ease;
}

.el-table tr {
  background-color: rgba(20, 20, 30, 0.9) !important;
  transition: all 0.3s ease;
}

.el-table--striped .el-table__body tr.el-table__row--striped td {
  background-color: rgba(25, 25, 35, 0.9) !important;
}

.el-table--striped .el-table__body tr.el-table__row--striped:hover > td {
  background-color: rgba(0, 150, 255, 0.2) !important;
  transform: translateX(2px);
}

.el-table tbody tr:hover > td {
  background-color: rgba(0, 150, 255, 0.2) !important;
  transform: translateX(2px);
}

.el-table--border {
  border-color: rgba(0, 150, 255, 0.3) !important;
}

.el-table--border::after,
.el-table--border::before {
  background-color: rgba(0, 150, 255, 0.3) !important;
}

.el-table .el-table__inner-wrapper::before {
  background-color: rgba(0, 150, 255, 0.3) !important;
}

/* Dialog 对话框样式 */
.el-dialog {
  background-color: rgba(20, 20, 30, 0.95) !important;
  border: 1px solid rgba(0, 150, 255, 0.3) !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.8) !important;
}

.el-dialog__header {
  background-color: rgba(15, 15, 25, 0.95) !important;
  border-bottom: 1px solid rgba(0, 150, 255, 0.3) !important;
  padding: 20px 20px 15px !important;
}

.el-dialog__title {
  color: #e0e0e0 !important;
}

.el-dialog__headerbtn .el-dialog__close {
  color: #e0e0e0 !important;
}

.el-dialog__headerbtn .el-dialog__close:hover {
  color: #00d4ff !important;
}

.el-dialog__body {
  background-color: rgba(20, 20, 30, 0.95) !important;
  color: #e0e0e0 !important;
  padding: 20px !important;
}

.el-dialog__footer {
  background-color: rgba(15, 15, 25, 0.95) !important;
  border-top: 1px solid rgba(0, 150, 255, 0.3) !important;
  padding: 15px 20px !important;
}

/* Form 表单样式 */
.el-form {
  background-color: transparent !important;
}

.el-form-item {
  background-color: transparent !important;
}

.el-form-item__label {
  color: #e0e0e0 !important;
  background-color: transparent !important;
}

.el-form-item__content {
  color: #e0e0e0 !important;
  background-color: transparent !important;
}

/* 确保表单中的所有输入框都是暗色 */
.el-form .el-input__wrapper,
.el-form .el-textarea__inner,
.el-form .el-select .el-input__wrapper {
  background-color: rgba(20, 20, 30, 0.9) !important;
  color: #e0e0e0 !important;
}

/* 确保对话框中的表单元素也是暗色 */
.el-dialog .el-input__wrapper,
.el-dialog .el-textarea__inner,
.el-dialog .el-select .el-input__wrapper {
  background-color: rgba(20, 20, 30, 0.9) !important;
  color: #e0e0e0 !important;
}

.el-dialog .el-input__inner,
.el-dialog .el-textarea__inner {
  background-color: rgba(20, 20, 30, 0.9) !important;
  color: #e0e0e0 !important;
}

/* 确保所有输入框和文本域的文字颜色 */
.el-input input,
.el-textarea textarea,
.el-input__inner,
.el-textarea__inner {
  background-color: rgba(20, 20, 30, 0.9) !important;
  color: #e0e0e0 !important;
}

/* 确保输入框在禁用状态下也是暗色 */
.el-input.is-disabled .el-input__wrapper,
.el-textarea.is-disabled .el-textarea__inner {
  background-color: rgba(15, 15, 25, 0.8) !important;
  color: rgba(255, 255, 255, 0.4) !important;
}

/* 确保所有可能的输入元素背景都是暗色 */
input[type="text"],
input[type="password"],
input[type="email"],
input[type="number"],
textarea {
  background-color: rgba(20, 20, 30, 0.9) !important;
  color: #e0e0e0 !important;
  border-color: rgba(0, 150, 255, 0.3) !important;
}

/* Upload 上传组件样式 */
.el-upload {
  background-color: transparent !important;
}

.el-upload__tip {
  color: rgba(255, 255, 255, 0.6) !important;
}

.el-upload-list {
  background-color: transparent !important;
}

.el-upload-list__item {
  background-color: rgba(20, 20, 30, 0.9) !important;
  border-color: rgba(0, 150, 255, 0.3) !important;
  color: #e0e0e0 !important;
}

.el-upload-list__item-name {
  color: #e0e0e0 !important;
}

/* Card 卡片样式 */
.el-card {
  background-color: rgba(20, 20, 30, 0.9) !important;
  border-color: rgba(0, 150, 255, 0.3) !important;
  color: #e0e0e0 !important;
}

.el-card__header {
  background-color: rgba(15, 15, 25, 0.95) !important;
  border-bottom: 1px solid rgba(0, 150, 255, 0.3) !important;
  color: #e0e0e0 !important;
  padding: 15px 20px !important;
}

.el-card__body {
  background-color: transparent !important;
  color: #e0e0e0 !important;
  padding: 20px !important;
}

.el-card__header .el-dropdown {
  color: #e0e0e0 !important;
}

.el-card__header .el-button {
  color: #e0e0e0 !important;
}

/* Tabs 标签页样式 */
.el-tabs {
  background-color: transparent !important;
}

.el-tabs__header {
  background-color: rgba(15, 15, 25, 0.95) !important;
  border-bottom: 1px solid rgba(0, 150, 255, 0.3) !important;
  margin-bottom: 20px !important;
}

.el-tabs__nav {
  background-color: transparent !important;
}

.el-tabs__item {
  color: rgba(255, 255, 255, 0.7) !important;
  border-bottom-color: transparent !important;
}

.el-tabs__item:hover {
  color: #00d4ff !important;
}

.el-tabs__item.is-active {
  color: #00d4ff !important;
  border-bottom-color: #00d4ff !important;
}

.el-tabs__content {
  background-color: transparent !important;
}

.el-tab-pane {
  background-color: transparent !important;
  color: #e0e0e0 !important;
}
</style>

